// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__3b5cp","AppLogo":"App_AppLogo__15FhL","AppLogoSpin":"App_AppLogoSpin__277cj","AppHeader":"App_AppHeader__1e3aq","AppLink":"App_AppLink__t-O5Q"};